import { SCORECARD_TAGS } from "../common.js";
import { xCardScorecardApi } from "../api.js";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
const xCardViewHooks = xCardScorecardApi.injectEndpoints({
  endpoints: (builder) => ({
    getxCardView: builder.query({
      query: ({ payload, workspaceId }) => {
        return {
          url: EnvironmentService.callXCardApiCommonInfra() ? `/workspaces/${workspaceId}/view/${payload.Mode}` : `/view/${payload.Mode}`,
          body: void 0,
          method: "GET",
          params: payload
        };
      },
      providesTags: (result, error, { cacheKey }) => [{ type: SCORECARD_TAGS.XCARD_STEP, cacheKey }]
    })
  })
});
const { usePrefetch: usexCardViewApiPrefetch, useGetxCardViewQuery } = xCardViewHooks;
export {
  useGetxCardViewQuery,
  usexCardViewApiPrefetch,
  xCardViewHooks
};
//# sourceMappingURL=view.js.map
